<!-- 头部 -->
<template>
  <div class="search-header">
    <div class="imgbox">
      <img src="@/assets/images/logo1.png" alt />
    </div>
    <div class="search" v-if="show_search">
      <form action="javascript:return true">
        <input type="text" placeholder="搜索" v-model="search_value" v-search="searchemit" @keyup.enter="search" />
      </form>
      <!-- <form @submit.prevent>
        <input type="search" placeholder="搜索" v-model="search_value" @keypress="search" />
      </form>-->
      <!-- <input type="text" placeholder="搜索" v-model="search_value" @keyup.13="search" @blur="search" /> -->
      <img src="@/assets/images/search.png" alt @click="search" />
    </div>
  </div>
</template>

<script>
export default {
  name: "search-header",
  props: ["show_search", "path_search"],
  data() {
    return {
      search_value: ""
    };
  },
  methods: {
    searchemit(){
      // return{ search:this.search_value, isMember:false}
    },
    search() {
        this.emit({ type: 'search',viewTitle:'搜索', extensionData:this.search_value})
      if (this.search_value && !this.search_value.match(/^[ ]+$/)) {
        this.$router.push({
          path: "/Search-result",
          query: { content: this.search_value, path: this.path_search }
        });
      } else {
        //   this.$toast("请填写内容后在进行搜索");
      }
    }
  }
};
</script>

<style lang='less'>
.search-header {
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0 10px;
  .imgbox {
    width: 128px;
    height: 54px;
    img {
      width: 100%;
      height: 100%;
      // margin: 6px 0 10px;
    }
  }
  .search {
    width: 125px;
    height: 26px;
    position: relative;
    input {
      // width: 100%;
      // height: 100%;
      width: 125px;
      height: 26px;
      outline: none;
      border: solid 1px #45a6af;
      border-radius: 5px;
      box-sizing: border-box;
      padding-left: 10px;
    }
    img {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public-components/Search-header.vue